import JosefinSansBold from '../assets/fonts/JosefinSans-Bold.ttf'

export default [
  {
    fontFamily: "Josefin Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    src: `url(${JosefinSansBold}) format('truetype')`,
  },
];
